import { QueryClient, useMutation, useQuery, useQueryClient, type UseQueryOptions } from "@tanstack/react-query";
import { ApiError, api } from "./api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (n, err) => !(err instanceof ApiError && (err.status === 0 || (err.status >= 400 && err.status < 500))) && n < 2,
      refetchOnWindowFocus: true,
      // Always run the request: without signal it falls back to this browser's saved copy.
      networkMode: "always",
    },
  },
});

/** GET with caching. The path is the cache key, so the same data is shared across screens. */
export function useApi<T>(path: string | null, options: Omit<UseQueryOptions<T>, "queryKey" | "queryFn"> = {}) {
  return useQuery<T>({ queryKey: [path], queryFn: () => api.get<T>(path!), enabled: !!path, ...options });
}

/** After any write, refresh what might have changed. Cheap and keeps every screen honest. */
export function invalidateAll(): Promise<void> {
  return queryClient.invalidateQueries();
}

export { useMutation, useQuery, useQueryClient };
